import {DropdownMenu} from 'quickstart/components/controls/DropdownMenu'
import {forwardRef} from 'react'
import {logger} from 'tizra'
import {NavLinkAccount, NavLinkAccountProps} from './NavLinkAccount'
import {NavLinkBookshelf, NavLinkBookshelfProps} from './NavLinkBookshelf'
import {NavLinkExpando, NavLinkExpandoProps} from './NavLinkExpando'
import {NavLinkLink, NavLinkLinkProps} from './NavLinkLink'
import {NavLinkMenu, NavLinkMenuProps} from './NavLinkMenu'
import * as S from './styles'

const log = logger('quickstart/components/layout/NavLink')

export type NavLinkProps =
  | ({type: 'account'} & NavLinkAccountProps)
  | ({type: 'bookshelf'} & NavLinkBookshelfProps)
  | ({type?: 'expando'} & NavLinkExpandoProps)
  | ({type?: 'link'} & NavLinkLinkProps)
  | ({type?: 'menu'} & NavLinkMenuProps)
  | {type: 'separator'}

const _NavLink = forwardRef<any, NavLinkProps>((props, ref) => {
  const {
    type = 'adminTag' in props ? 'expando' : 'items' in props ? 'menu' : 'link',
    ...rest
  } = props
  switch (type) {
    case 'bookshelf':
      return <NavLinkBookshelf {...rest} ref={ref} />
    case 'account':
      return <NavLinkAccount {...rest} ref={ref} />
    case 'expando':
      return <NavLinkExpando {...rest} ref={ref} />
    case 'link':
      return <NavLinkLink {...rest} ref={ref} />
    case 'menu':
      return <NavLinkMenu {...rest} ref={ref} />
    case 'separator':
      return <DropdownMenu.Separator ref={ref} />
    default:
      log.error(`unreachable case: type="${type}" with props=`, props)
      return null
  }
})

export const NavLink = Object.assign(_NavLink, {Group: S.NavLinkGroup})
